export default __webpack_public_path__ + "static/media/ie.fed6e4f7.svg";